import { render } from "./login-page.vue?vue&type=template&id=10309e3b&scoped=true"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"

import "./login-page.vue?vue&type=style&index=0&id=10309e3b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10309e3b"]])

export default __exports__